import React, { Fragment } from 'react'
import {
    List, Datagrid, Filter, ShowButton, UrlField,Button, TextInput, TextField, EditButton, BulkDeleteButton, FunctionField, DeleteButton, useRecordContext, Link
} from 'react-admin'
import { InfluencerStatusSelectInput,SBOCareCategorySelectInput } from '../../UI/Input/SelectInput'
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <InfluencerStatusSelectInput label="Status" source="status" alwaysOn />
        <SBOCareCategorySelectInput label="category" source="category" alwaysOn />
    </Filter>
)
const ListActionButtons = ({ ...props }) => {
    return (<>
        <BulkDeleteButton {...props} undoable={false}
            confirmTitle="Delete File Record"
            confirmContent={"Are you sure you want to delete this record?"} />
    </>)
}
const ProfileidFiled = (props)=>{
    const record = useRecordContext();  
    return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event)=>event.stopPropagation()} />
  )}


const SbocareList = ({ ...props }) => {

    return (
        <List {...props} title="Sbocare" bulkActionButtons={<ListActionButtons />} filters={<ListFilter />} sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid >
                
                <ProfileidFiled source="profile_id" label="Profile Id" />  
                <TextField source="user.name" label="Name" />
                <TextField source="category" label="Category" />
                <TextField source="created_at" label="Submit Date" />
                <FunctionField source="status" label="Status" render={record => {
                    if (record['status'] === 'Reject') {
                        return (<span style={{ color: 'red' }}>Reject</span>)
                    } else if (record['status'] === 'Pending') {
                        return (<span style={{ color: 'orange' }}>Pending</span>)
                    } else {
                        return (<span style={{ color: 'green' }}>Approved</span>)
                    }
                }} />

                <TextField source="decline_reason" label="Reason" />
              
                {useCheckPermissions('SboCare_Edit')?<FunctionField source="status" label="Edit Action" render={record => {
                   
                        return (<EditButton />)
                    

                }} />:null}
                {useCheckPermissions('SboCare_View')?<ShowButton />:null}

            </Datagrid>

        </List>
    )
}


export default SbocareList